const { Link } = require("react-router-dom");

const FourOfFour = () => {
  return (
    <div className="text-center m-5">
      <h4>
        هذه الصفحة غير موجودة، تصفح قائمة المتاجر كاملة <Link to="/">هنا</Link>
      </h4>
    </div>
  );
};

export default FourOfFour;
